export default __webpack_public_path__ + "static/media/logoTypography.893ec507.png";